<template>
  <div class="score-container">   
    <div class="score-header">
      <label class="title">积分抵扣：</label>
      <label class="score" v-if="this.currentScore">可用{{this.currentScore}}积分(每积分抵扣{{this.rule}}元)</label>
      <label class="score" v-else>无可用积分</label>
    </div>
    <div class="bottom-wrapper">
      <input
        type="number"
        :disabled="!this.currentScore ||  this.currentScore==0"
        :placeholder="placeholder"
        :min="0" 
        v-model="value" 
        :max="this.currentScore"
        @input="onInput">        
      </input>
    </div>       
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import { scoreGet } from '../../../api/score';

export default {
  props: {
    default: {
      type: String,
    },
    maxUseScore: 0,    
  },
  data () {
    return {
      value: this.default,
      currentScore: null,
      percent:null,
      rule: null,
      
    }
  }, 
  computed: {
    placeholder(){
      if(this.maxUseScore > 0){
        return '该订单最多可使用'+Math.floor(this.maxUseScore * this.percent * 100)+'个积分'
      }else{
        return '在此输入积分'
      }
    }
  },
  methods: {
    ...mapMutations({
      saveScoreInfo: 'saveScoreInfo',  
    }),
    onInput() {
      this.value = Number(this.value)
      this.currentScore = Number(this.currentScore)
      if(this.value !=null & this.value != ''){
        if (this.value > this.currentScore) {
          this.value = this.currentScore;
        }
        if (this.value/100 > this.maxUseScore * this.percent) {
          this.value =  Math.floor(this.maxUseScore*100  * this.percent);
        }
        if (this.value <= 0) {
          this.value = 0;
        }
      }else{
        this.value = 0;
      }
      this.saveScoreInfo(this.value);
    },
  },
  created() {
    scoreGet().then( response => {
      this.currentScore = response.score;
      this.rule = response.rule;
      this.percent = response.percent
    },
    error => {}
    );
  },
}
</script>

<style lang="scss" scoped>
  .score-container {    
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    background-color: #fff; 
    .bottom-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: stretch;
      margin: 15px;      
      input {
        flex: 1;
        font-size: 14px;
        color: #4E545D;
        background-color: #F7F8FA;
        padding: 10px;
        border: none;
        border-radius: 2px;
        &:focus {
          outline-style: none;
        }
      }
    }    
  }
  .score-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 15px 0px 15px;
    .title {
      font-size: 16px;
      color: #4E545D;
    }
    .score {
      font-size: 12px;
      color: #FA800A;
    }
  } 
</style>





// WEBPACK FOOTER //
// src/page/checkout/child/CheckoutScore.vue